import './style.css';
import ProductInfoTable from '../productInfoTable';
import ProductInfoPanel from '../productInfoPanel';
import { Row, Col } from 'react-bootstrap';

interface AttributeItem {
  name: string;
  title: string;
  value?: string;
  columns?: any;
}

const DetailsSection = (props: any) => {

  let thisModel = props.attributes;
  let marketingSentences = props.marketingSentences;
  let description = props.description;
  let originCountry = null;
  if (thisModel && thisModel['Single']) {
    let item = thisModel['Single'].find((element: any) => element.name === 'Country_of_Origin');
    if (item) originCountry = item.value;
  }
  let restList: Array<AttributeItem> = [];
  let leftList: Array<AttributeItem> = [];
  let rightList: Array<AttributeItem> = [];
  if (thisModel && marketingSentences) {
    restList = thisModel['Single']
      .filter((it: any) => it.name !== 'Country_of_Origin' && it.name !== 'Feature_Points')
      .map((it: any) => ({ name: it.name, title: it.title, value: it.value }));

    restList = restList.concat(
      Object.keys(marketingSentences)
        .filter((it) => it !== 'Features & Benefits' && it !== 'Feature Points')
        .map<AttributeItem>((it) => ({ name: it, title: it, columns: marketingSentences[it] }))
    );

    restList = restList.concat(
      Object.keys(thisModel)
        .filter((it) => it !== 'Single' && it !== 'Classification')
        .map<AttributeItem>((it) => ({ name: it, title: it, columns: thisModel[it] }))
    );
    leftList = restList.filter((it: AttributeItem, i: number) => i % 2 === 0);
    rightList = restList.filter((it: AttributeItem, i: number) => i % 2 !== 0);
  }

  return (
    <>
      <section>
        <Row>
          {thisModel && (
            <Col xl={6}>
              <ProductInfoTable
                key="Classification"
                columns={thisModel['Classification']}
                title="Classification"
                alwaysExpand={true}
              />
            </Col>
          )}
          <Col xl={6}>
            <section>
              {originCountry && (
                <Row>
                  <ProductInfoPanel
                    key="Country_of_Origin"
                    title="Country of Origin"
                    body={originCountry}
                    alwaysExpand={true}
                  />
                </Row>
              )}
              {description && (
                <Row>
                  <ProductInfoPanel
                    key={`description_mpd`}
                    title={'Marketing Product Description'}
                    body={description.marketingProductDescription}
                    alwaysExpand={true}
                  />
                </Row>
              )}
              {marketingSentences && marketingSentences['Feature Points'] && (
                <Row>
                  <div className="panel panel-default">
                    <div className="panel-heading">
                      <span className="panel-title panel-title-colored">Feature Points</span>
                    </div>
                    <div className="panel-body">
                      {marketingSentences['Feature Points'].map((item: any, index: number) => {
                        return (
                          <div className="w-100" key={index}>
                            {item.title}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </Row>
              )}
              {marketingSentences && marketingSentences['Features & Benefits'] && (
                <Row>
                  <ProductInfoTable
                    key="Features_Benefits"
                    columns={marketingSentences['Features & Benefits']}
                    title="Features & Benefits"
                    alwaysExpand={true}
                  />
                </Row>
              )}
            </section>
          </Col>
        </Row>
        <Row>
          <Col xl={6}>
            {leftList.map((it: AttributeItem, i: number) => {
              if (!it.columns) {
                return (
                  <ProductInfoPanel
                    key={'attribute_l_' + it.name + i}
                    title={it.title}
                    body={it.value}
                  />
                );
              } else {
                return (
                  <ProductInfoTable
                    key={'attribute_l_' + it.name + i}
                    columns={it.columns}
                    title={it.title}
                  />
                );
              }
            })}
            {description && (
              <ProductInfoPanel
                key={`description_specifications`}
                title={'Specifications'}
                body={description.specifications}
              />
            )}
            {description && (
              <ProductInfoPanel
                key={`description_ipd`}
                title={'Internal Product Description'}
                body={description.internalProductDescription}
              />
            )}
          </Col>
          <Col xl={6}>
            {rightList.map((it: AttributeItem, i: number) => {
              if (!it.columns) {
                return (
                  <ProductInfoPanel
                    key={'attribute_l_' + it.name + i}
                    title={it.title}
                    body={it.value}
                  />
                );
              } else {
                return (
                  <ProductInfoTable
                    key={'attribute_l_' + it.name + i}
                    columns={it.columns}
                    title={it.title}
                  />
                );
              }
            })}
          </Col>
        </Row>
      </section>
    </>
  );
};

export default DetailsSection;
